
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 172 172"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticStyle:{"mix-blend-mode":"normal"},attrs:{"fill":"none","stroke-miterlimit":"10","font-family":"none","font-weight":"none","font-size":"none","text-anchor":"none"}},[_c('path',{attrs:{"d":"M0 172V0h172v172z"}}),_c('path',{attrs:{"d":"M86 172c-47.496 0-86-38.504-86-86S38.504 0 86 0s86 38.504 86 86-38.504 86-86 86z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M76.605 28.667a2.28 2.28 0 00-2.273 2.071l-1.198 11.904a34.18 34.18 0 00-8.298 4.815l-10.93-4.927a2.291 2.291 0 00-2.933.93l-9.395 16.28a2.288 2.288 0 00.65 3.002l9.742 6.999c-.213 1.576-.37 3.164-.37 4.792 0 1.629.152 3.216.37 4.793l-9.731 6.999a2.29 2.29 0 00-.65 3l9.395 16.271a2.286 2.286 0 002.923.941l10.929-4.927a34.141 34.141 0 008.309 4.815l1.187 11.915a2.275 2.275 0 002.273 2.06h18.79a2.284 2.284 0 002.273-2.072l1.198-11.914a34.507 34.507 0 008.31-4.804l10.928 4.927a2.274 2.274 0 002.923-.94l9.395-16.271a2.286 2.286 0 00-.65-3.001l-9.742-6.999c.218-1.57.37-3.164.37-4.793 0-1.628-.146-3.216-.37-4.792l9.743-7a2.294 2.294 0 00.65-3l-9.396-16.27a2.286 2.286 0 00-2.923-.941l-10.929 4.927a34.14 34.14 0 00-8.309-4.815l-1.198-11.915a2.275 2.275 0 00-2.273-2.06zM86 57.333c9.5 0 17.2 7.7 17.2 17.2s-7.7 17.2-17.2 17.2-17.2-7.7-17.2-17.2 7.7-17.2 17.2-17.2zm-57.333 57.334v17.2c0 6.267 5.2 11.466 11.466 11.466h91.734c6.267 0 11.466-5.2 11.466-11.466v-17.2h-11.466v17.2H40.133v-17.2z","fill":"#fff"}})])])
          )
        }
      }
    